import styled from 'styled-components';
import { BRAND } from '@/constants/brand';

export const Container = styled.div<{ $fullscreen: boolean; $compact?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $fullscreen, $compact }) =>
    $fullscreen
      ? `
    position: fixed;
    inset: 0;
    z-index: 1000;
    background-color: ${BRAND.ink};
  `
      : `
    width: 100%;
    min-height: ${$compact ? '80px' : '320px'};
    padding: ${$compact ? '16px 0' : '0'};
    background-color: transparent;
  `}

  .ant-spin-dot-item {
    background-color: ${BRAND.lavanda};
  }
`;
